import { Observable } from 'rxjs';
import { map, pluck, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { StorageMsg, StorageActions } from '@wearejh/m2-pwa-engine/lib/storage';

import { Actions, STORAGE_KEY_CART } from '../cart.actions';
import { AppendState, CartState } from '../cart.reducer';

const ONE_DAY = 60 * 60 * 24 * 1000;
const THIRTY_DAYS = ONE_DAY * 30;

export function cartPersist(action$: Observable<any>, state$: Observable<AppendState>): Observable<Action> {
    return action$.pipe(
        ofType<Actions>('Cart.Persist'),
        withLatestFrom<Action, [Action, CartState]>(state$.pipe(pluck('cart'))),
        map(([, cart]) => {
            // Items to *never* persist
            const { deleting, updating, messages, itemMessages, status, ...rest } = cart;
            return StorageMsg(StorageActions.Set, {
                key: STORAGE_KEY_CART,
                value: rest,
                expiry: new Date().getTime() + THIRTY_DAYS,
            });
        }),
    );
}
